module.exports = __webpack_public_path__ + "files/3bd6cf3a8572f449b570c44dce84c141.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icon50x50.png
 ** module id = 811
 ** module chunks = 0
 **/